var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { icons: true, value: _vm.open },
      on: {
        input: function($event) {
          return _vm.$emit("open", false)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "list",
          staticClass:
            "select-options d-flex flex-column justify-content-center align-items-center",
          attrs: {
            id: _vm.selectUniqueId,
            role: "listbox",
            tabindex: "-1",
            "aria-activedescendant": _vm.activeDescendant,
            "aria-labelledby": _vm.labelId || ""
          },
          on: {
            keydown: function($event) {
              return _vm.handleKeydown($event)
            },
            blur: function($event) {
              return _vm.$emit("open", false)
            }
          }
        },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "select-option secondary-text d-block w-100 py-1",
              class: _vm.selectClasses(option),
              attrs: {
                id: _vm.optionUniqueId(index),
                role: "option",
                "aria-selected": _vm.ariaSelected(option)
              },
              on: {
                click: function($event) {
                  return _vm.select(option)
                }
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.labels[index]) + "\n        "
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }